import { render, staticRenderFns } from "./MultiFields.vue?vue&type=template&id=b676297e&scoped=true&"
import script from "./MultiFields.vue?vue&type=script&lang=js&"
export * from "./MultiFields.vue?vue&type=script&lang=js&"
import style0 from "./MultiFields.vue?vue&type=style&index=0&id=b676297e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b676297e",
  null
  
)

export default component.exports